import "./Home.module.css";
import VilHeader from "@/reusable_sections/Header";
import BuffalosGreenConnection from "./sections/BuffalosGreenConnection";
import FourDecadesOfQuality from "./sections/FourDecadesOfQuality";
import ServiceSpectrum from "./sections/ServiceSpectrum";
import LocalProjectShowcase from "./sections/LocalProjectShowcase";
import VoiceOfTheClient from "./sections/VoiceOfTheClient";
import RequestAFreeEstimate from "./sections/RequestAFreeEstimate";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <VilHeader />
      <BuffalosGreenConnection />
      <FourDecadesOfQuality />
      <ServiceSpectrum />
      <LocalProjectShowcase />
      <VoiceOfTheClient />
      <RequestAFreeEstimate />
      <SiteFooter />
    </div>;
}